import apiUrl from './api';
import { postWithAuth } from '@/lib/httpAdapter';

/**
 * Change a user's role through the authenticated `assignUserRole/` endpoint,
 * which runs the backend role rules (Owner-only grants, an Admin limited to
 * their own team, last-Owner/Admin guards). `createUser/` is unauthenticated
 * and ignores role changes, so it must not be used for this.
 */
export const assignUserRole = async (userUUID: string, role: string) => {
  const response = await postWithAuth(`${apiUrl}assignUserRole/`, {
    UserUUID: userUUID,
    Role: role,
  });
  if (!response.ok) {
    throw new Error("We couldn't update this role. Try again.");
  }
  const raw = await response.json();
  const data = typeof raw === 'string' ? JSON.parse(raw) : raw;
  if (data?.Error) {
    throw new Error(String(data.Error));
  }
  return data;
};
